const path = global.domain.name === 'localhost' ? 't1.besttour.com.tw' : global.domain.name;
    
export const API = {
  // 寄信
  SEND_MAIL: { method: 'POST', api: 'send_mail', baseURL: 'https://api-dev.besttour.com.tw/api/', test: false },
  // 取得行程詳情資料
  TRAVEL_DETAIL: { method: 'GET', api: 'travel_detail_info.asp', baseURL: 'https://travelapi.besttour.com.tw/api/', test: false },
  // 行程搜尋
  TOUR_SEARCH: { method: 'POST', api: 'query_List_new.asp', test: false },
  // 行程細節
  TRAVEL_DETAIL_SCHEDULE: { method: 'GET', api: 'travel_detail_SCHEDULE.asp', baseURL: 'https://travelapi.besttour.com.tw/api/', test: false },
  // 搜尋行程列表 - 可將多組團號當成關鍵字 (因req的資料結構改為POST送出)
  TOUR_SEARCH_N1: { method: 'POST', api: 'query_list_new_1.asp', test: false },
  // 送出訂單
  ORDER_FORM_CUSTOM: { method: 'POST', api: 'order_form_custom.asp', baseURL: 'https://travelapi.besttour.com.tw/api/', test: false },
  // 查詢訂單
  CUSTOM_REQUEST: { method: 'GET', api: 'custom_request.asp', baseURL: 'https://travelapi.besttour.com.tw/api/', test: false },
  // 自費推薦
  TRAVEL_DETAIL_EXPENSE: { method: 'GET', api: 'travel_detail_expense.asp', baseURL: 'https://travelapi.besttour.com.tw/api/', test: false },
  // 會員資料
  MEMBER_LOGIN_NEW: { method: 'POST', api: 'member_login_new1.asp', baseURL: 'https://travelapi.besttour.com.tw/api/', test: false },
  // 取得行程基本資訊
  TOUR_DETAIL_INFO: { method: 'GET', api: 'travel_detail_info.asp', test: false },
  // 取得國家資訊
  LEFT_QUERY_COUNTRY: { method: 'GET', api: `https://${path}/e_web/json/left_query_country.json`, test: false },
};
